import React from 'react';
import cn from 'classnames';

import {isTranslate} from 'shared/lib/lang';

import styles from './MetricGroup.module.scss';

interface MetricGroupProps {
    title: string;
    metrics: string[];
    selectedMetrics: string[];
    // eslint-disable-next-line no-unused-vars
    onSelectGroup: (metrics: string[]) => void;
    // eslint-disable-next-line no-unused-vars
    onDeselectGroup: (metrics: string[]) => void;
}

const MetricGroup: React.FC<MetricGroupProps> = ({
    title,
    metrics,
    selectedMetrics,
    onSelectGroup,
    onDeselectGroup,
}) => {
    const selectedMetricsInGroup = metrics.filter(metric =>
        selectedMetrics.includes(metric),
    );

    const allSelected = selectedMetricsInGroup.length === metrics.length;
    const noneSelected = selectedMetricsInGroup.length === 0;

    const handleSelectAll = () => {
        onSelectGroup(metrics);
    };
    const handleDeselectAll = () => {
        onDeselectGroup(metrics);
    };

    return (
        <div className={styles.container}>
            <span className={styles.title}>{title}:</span>
            <div className={styles.blockButtons}>
                <button
                    onClick={handleSelectAll}
                    className={cn(
                        styles.button,
                        allSelected
                            ? isTranslate()
                                ? styles.enActive
                                : styles.ruActive
                            : '',
                    )}
                >
                    Все
                </button>
                <button
                    onClick={handleDeselectAll}
                    className={cn(
                        styles.button,
                        noneSelected
                            ? isTranslate()
                                ? styles.enActive
                                : styles.ruActive
                            : '',
                    )}
                >
                    Ничего
                </button>
            </div>

        </div>
    );
};

export default MetricGroup;